import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../api/client";
import { fetchQueueHealth, type QueueHealthRow } from "../api/admin";

/**
 * D-121 — PM web Queue health hook.
 *
 * staleTime: 0 + refetchInterval: 30s = the dedicated dashboard view re-polls
 * every 30 seconds so PM sees the latest worker queue state. The
 * WorkerList-column variant uses staleTime: 30s instead (lower priority for
 * the at-rest worker list view).
 */
export const QUEUE_HEALTH_KEY = ["queue-health"] as const;

export function useQueueHealth() {
  return useQuery<QueueHealthRow[], ApiError>({
    queryKey: QUEUE_HEALTH_KEY,
    queryFn: fetchQueueHealth,
    staleTime: 0,
    refetchInterval: 30_000,
    refetchOnWindowFocus: false,
  });
}
